module.exports = __webpack_public_path__ + "static/img/hzhb1.83db9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb1.png
// module id = WB4e
// module chunks = 0